module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cta":{"content":"Are you considering going public, and does your company have growth potential?","title":"Considering going public?"}},"ar":{"cta":{"content":"هل تفكر في تحويل شركتك إلى شركة مساهمة عامة، وهل تمتلك شركتك إمكانات تحقيق النمو؟","title":"مهتم بالإدراج في السوق؟"}}}')
  delete Component.options._Ctor
}
